import { BASE_URL } from 'src/config';
import { getSession } from './jwt';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const baseQuery = (withHeader = true) =>
  fetchBaseQuery({
    baseUrl: BASE_URL,
    jsonContentType: 'application/json',
    ...(withHeader && {
      headers: {
        lt: getSession(),
        ln: 'fa',
        'Content-Type': 'application/json',
      },
    }),
  });

export function tagType(tag) {
  return { id: tag, type: tag };
}
